export const initActiveBtn = function() {
  const btnActive = document.querySelectorAll('[data-active-btn]');

  activeToggele(btnActive, 'is-active');

  activeToggleParent('[data-active-item="btn"]', '[data-active-item="parent"]', 'is-active');

  const basketTableCheck = document.querySelectorAll('[data-btn-selected]');
  activeToggeleAll(basketTableCheck, 'is-active');

  const btnActiveAll = document.querySelectorAll('[data-active-btn-all]');
  activeToggeleAll(btnActiveAll, 'is-active');

  const btnFormHideSubmit = document.querySelectorAll('[data-btn-readonly]');
  if (btnFormHideSubmit.length > 0) {
    btnFormHideSubmit.forEach((item) => {
      item.addEventListener('click', () => {
        const parent = item.closest('.form--readonly');

        if (parent) {
          const inputs = parent.querySelectorAll('input[readonly]');
          const textarea = parent.querySelectorAll('textarea[readonly]');
          const selects = parent.querySelectorAll('.choices.is-disabled');
          const blockFile = parent.querySelector('.form__group--file');
          const btnPassword = parent.querySelectorAll('[data-password-show]');
          if (blockFile) {
            blockFile.classList.add('is-show');
          }

          inputs.forEach((i) => {
            i.removeAttribute('readonly');
          })

          textarea.forEach((i) => {
            i.removeAttribute('readonly');
          })

          btnPassword.forEach((i) => {
            i.removeAttribute('disabled');
          })

        }
      })
    })
  }

  const btnFormCancel = document.querySelectorAll('[data-btn-readonly-cancel]');
  if (btnFormCancel.length > 0) {
    btnFormCancel.forEach((item) => {
      item.addEventListener('click', (i) => {
        i.preventDefault();
        const parent = item.closest('.form--readonly');
        const btnEdit = parent.querySelector('[data-btn-readonly]');
        const blockFile = parent.querySelector('.form__group--file');

        if (blockFile) {
          if (blockFile.classList.contains('is-show')) {
            blockFile.classList.remove('is-show');
          }
        }

        if (btnEdit.classList.contains('is-active')) {
          btnEdit.classList.remove('is-active');
        }

        if (parent) {
          const inputs = parent.querySelectorAll('input');
          const textarea = parent.querySelectorAll('textarea');
          const btnPassword = parent.querySelectorAll('[data-password-show]');

          inputs.forEach((i) => {
            i.setAttribute('readonly', '');
          })
          textarea.forEach((i) => {
            i.setAttribute('readonly', '');
          })
          btnPassword.forEach((i) => {
            i.setAttribute('disabled', '');
          })
        }

      })
    })
  }

  function activeToggele(array, classActive) {
    if (array) {
      array.forEach((item) => {
        item.addEventListener('click', (evt) => {
          evt.preventDefault();
          if (item.classList.contains(classActive)) {
            item.classList.remove(classActive);
          } else {
            array.forEach((i) => {
              if (i.classList.contains(classActive)) {
                i.classList.remove(classActive)
              }
            })
            item.classList.add(classActive);
          }
        })
      })
    }
  }

  function activeToggleParent(btnClass, parentClass, classActive) {
    const btnItem = document.querySelectorAll(btnClass);
    if (btnItem) {
      btnItem.forEach((item) => {
        item.addEventListener('click', (evt) => {
          evt.preventDefault();
          if (item.classList.contains(classActive)) {
            item.classList.remove(classActive);
          } else {
            const parent = item.closest(parentClass);
            const itemBtns = parent.querySelectorAll(btnClass);
            itemBtns.forEach((i) => {
              if (i.classList.contains(classActive)) {
                i.classList.remove(classActive)
              }
            })
            item.classList.add(classActive);
          }
        })
      })
    }
  }

  function activeToggeleAll(array, classActive) {
    if (array) {
      array.forEach((item) => {
        item.addEventListener('click', (evt) => {
          evt.preventDefault();
          item.classList.toggle(classActive);

          if (item.classList.contains('table-all__selected--all')) {
            if (item.classList.contains(classActive)) {
              basketTableCheck.forEach((i) => {
                i.classList.add(classActive);
              })
            } else {
              basketTableCheck.forEach((i) => {
                if (i.classList.contains(classActive)) {
                  i.classList.remove(classActive);
                }
              })
            }
          }
        })
      })
    }
  }
}
